import React, {useEffect} from 'react'
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from '@mui/material/CircularProgress';

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useListDealsStore} from "../../stores/listDealsStore";
import {useShallow} from "zustand/react/shallow";

export const ListDealsPageHeader = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {
        setSearch,
        search,
        isLoading,
    } = useListDealsStore(
        useShallow((state) => ({
            search: state.search,
            setSearch: state.setSearch,
            isLoading: state.isLoading,
        }))
    )

    useEffect(function clearSearchOnUnmount() {
        return () => {
            setSearch('')
        };
    }, []);

    return (
        <div
            className={'ListDealsPage_header'}
            style={{
                flexDirection: isTabletOrMobile ? 'column' : 'row'
            }}
        >
            <div
                className={'ListDealsPage_header-name'}
            >
                <Typography
                    sx={{
                        fontSize: '24px',
                        color: '#666'
                    }}
                    component="div"
                >
                    Quotes
                </Typography>
            </div>

            <div className={'ListDealsPage_header-search-container'}>
                <input
                    className=""
                    type="text"
                    value={search}
                    placeholder={'Keyword search a car'}
                    onChange={(e) => setSearch(e.target.value)}
                />
                {
                    isLoading ?
                        <CircularProgress size={20} sx={{ color: "#666666"}}/> :
                        <SearchIcon/>
                }
            </div>

        </div>
    )
}